import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { item } from "@scaffold/editor/items";
import { Router, ActivatedRoute } from "@angular/router";
import { ViewModalComponent } from "@scaffold/dialogs/view-modal/view-modal.component";
import { CourseService } from "@scaffold/services/course.service";
import { UserService } from "@services/user.service";
import { ScaffoldDialogService, ScaffoldDialogRef } from "@app/framework/dialog/scaffold-dialog.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-view",
  templateUrl: "./view.component.html",
  styleUrls: ["./view.component.scss"],
})
export class ViewComponent implements OnInit, OnDestroy {
  public destroy$: Subject<boolean> = new Subject<boolean>();
  private _items: item[];
  @Input("items")
  set items(items) {
    // console.log(items);
    this._items = items;
  }
  get items() {
    return this._items;
  }
  @Input() info: any;
  @Input() linkList: any;
  @Output() openViewHandler = new EventEmitter<string>();
  @Output() openLinkHandler = new EventEmitter<string>();
  @Output() deleteDataEvent = new EventEmitter<string>();
  @Output() refreshList = new EventEmitter<string>();
  @Output() moveHandler = new EventEmitter<any>();
  @Input() data: any = {};
  @Input() active;
  @Input() childview;
  dialogRef: ScaffoldDialogRef;
  userInfo;
  userInfoSub;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: ScaffoldDialogService,
    private courseService: CourseService,
    private userService: UserService
  ) {}

  ngOnInit() {
    if (this.info) this.info.route = this.route;
    if (this.linkList) this.info.linkList = this.linkList;
    // console.log(this);
    this.userInfoSub = this.userService
      .getRoleDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data.role) this.userInfo = data;
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openView(a, i) {
    if (this.openViewHandler.observers.length > 0) {
      this.openViewHandler.emit(a);
    } else {
      this.openViewLocal(a, i);
    }
  }
  openLink(a, i) {
    console.log(a);
    if (this.openLinkHandler.observers.length > 0) {
      this.openLinkHandler.emit(a);
    } else {
      this.openLinkLocal(a, i);
    }
  }
  openLinkLocal(event: any, item: any) {
    console.log(item);
    event.preventDefault();

    var navConfig = {};
    if (this.route.parent.component) {
      navConfig["relativeTo"] = this.route.parent;
    }

    this.router.navigate([this.info.type, this.info.id], navConfig);
  }

  openViewLocal(mode: any, item: any) {
    console.log(this);
    let settings: any = {
      context: {
        data: {
          mode: mode,
          item: this.info || this.info.children,
          parent: { id: this.courseService.id, type: "course" },
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe((result) => {
      console.log(result);
      console.log(this.info);
      if (result && (result !== "string" || result.length > 0)) {
        this.refreshList.emit("refresh");
      }
    });
  }

  delete(a) {
    console.log(a);
    this.deleteDataEvent.emit(a);
  }
  moveItem(e) {
    console.log("move view");
    this.moveHandler.emit("move");
  }
}
